import { text } from '@storybook/addon-knobs';
import { storiesOf } from '@storybook/react';
import * as React from 'react';
import { Button } from './button';

storiesOf('risk components button', module).add('default', () => {
  return <Button name={'button1'} text={'click'} />;
});
